module.exports = __webpack_public_path__ + "static/triplok-logo-7b236fe84b19d76efa51f0035af58203.svg";